<div class="p-4 overflow-auto h-[85vh]">

     <div class="flex justify-between items-center mb-3 -mt-5 w-full">
<!-- LEFT SIDE: TITLE -->
  <div>
    <h3 class="m-0 text-xl font-semibold">Client Add-Ons</h3>
    <p class="text-gray-500 text-sm mt-1">Manage Client Add-Ons</p>
  </div>

  <!-- RIGHT SIDE: SEARCH + BUTTON -->
  <div class="flex items-center gap-3">

    <!-- SEARCH BAR -->
    <div class="flex items-center gap-2 border rounded-lg px-3 py-2 bg-white">
      <i class="pi pi-search text-gray-500"></i>
      <input 
        pInputText 
        placeholder="Search packages..." 
        class="outline-none border-none p-0"
      />
    </div>

    <!-- ADD PACKAGE BUTTON -->
    <p-button 
      label="New Add-On" 
      icon="pi pi-plus" 
      (onClick)="openAddModal()">
    </p-button>

  </div>
</div>
    <p-table [value]="clientPackage" [rows]="rows" [totalRecords]="totalRecords"  [loading]="loading">
  
      <ng-template pTemplate="header">
        <tr>
          <th>Client Name</th>
          <th>Package Name</th>
          <th>Addon Name</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-package >

        <tr>
          <td>{{package?.subscription?.client?.name}}</td>
          <td>
            <span class="font-medium text-blue-600">
              {{package?.package_subscription?.package?.package_name || 'N/A'}}
            </span>
          </td>
          <td>{{package?.package_addon?.name}}</td>
          <td>
           {{package.status}}
          </td>
          <td class="text-center">
            <p-button
              icon="pi pi-ellipsis-v"
              class="p-button-text p-button-rounded"
              (onClick)="openMenu($event, package)"
            ></p-button>

            <p-menu
              #menu
              [popup]="true"
              [model]="menuItems"
              appendTo="body"
            ></p-menu>
          </td>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="loading">
        <tr>
          <td colspan="8" class="text-center">
            <p-progressSpinner></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="8"  class="no-data-record-found">
            <p>No records found</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  
  
  </div>
  
  <!-- <ng-container *ngIf="displayAddModal">
  <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-assign-addon
    (reload)="reload()" 
    [allPackages]="allPackages"
    [clientId]="clientId" (close)="displayAddModal= false"></app-assign-addon>
  </p-dialog>
  </ng-container>

   <ng-container *ngIf="displayEditModel">
  <p-dialog [(visible)]="displayEditModel" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-create-client-package
    (reload)="reload()" 
    [allPackages]="allPackages"
    [type]="'Update'"
    [clientDataToEdit]="clientDataToEdit"
    [clientId]="clientId" (close)="displayEditModel= false"></app-create-client-package>
  </p-dialog>
  </ng-container> -->

<ng-container *ngIf="showDeleteModal">
  <p-dialog [(visible)]="showDeleteModal" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
    <div class="flex items-center justify-center dialog-header relative">
      Delete Add-on

      <div class="absolute right-2">
        <button (click)="showDeleteModal = false" class="outline-none p-5">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <div class="dialog-content p-5">

      <div class="text-center font-medium text-lg">
        Are you sure you want to delete the add-on:
        <span class="font-bold text-red-500">
          {{ clientDataToEdit.id }}?
        </span>
      </div>

      <div class="flex gap-4 mt-7 justify-end">
        <p-button label="Cancel" severity="secondary" variant="outlined" (click)="showDeleteModal = false">
        </p-button>

        <p-button label="Delete" severity="danger" icon="pi pi-trash" (click)="deleteAddonConfirm()" [loading]="isDeleting"
          [disabled]="isDeleting">
        </p-button>
      </div>

    </div>

  </p-dialog>
</ng-container>
